import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import type { Entry } from '../api/entries'
import { getPublicFeed } from '../api/entries'
import { EntryCard } from '../components/Entry/EntryCard'
import { usePageHeader } from '../hooks/usePageHeader'

const PAGE_SIZE = 50

export function PublicFeed() {
  const [entries, setEntries] = useState<Entry[]>([])
  const [offset, setOffset] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    getPublicFeed(PAGE_SIZE, 0)
      .then((data) => {
        setEntries(data)
        setHasMore(data.length === PAGE_SIZE)
        setOffset(PAGE_SIZE)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [])

  const publicFeedActions = useMemo(() => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      <a href="/feed.atom" style={{ fontSize: '0.85rem', opacity: 0.5 }}>atom feed</a>
      <Link to="/login" style={{ fontSize: '0.85rem', opacity: 0.6 }}>log in</Link>
    </div>
  ), [])

  usePageHeader('public posts', publicFeedActions)

  function loadMore() {
    getPublicFeed(PAGE_SIZE, offset)
      .then((data) => {
        setEntries((prev) => [...prev, ...data])
        setHasMore(data.length === PAGE_SIZE)
        setOffset((prev) => prev + PAGE_SIZE)
      })
      .catch(console.error)
  }

  return (
    <div>
      {loading ? (
        <p>loading…</p>
      ) : entries.length === 0 ? (
        <p style={{ opacity: 0.5 }}>nothing public yet</p>
      ) : (
        <>
          {entries.map((e) => (
            <EntryCard key={e.id} entry={e} />
          ))}
          {hasMore && (
            <button type="button" onClick={loadMore} style={{ marginTop: '1rem' }}>
              load more
            </button>
          )}
        </>
      )}
    </div>
  )
}
